module.exports = __webpack_public_path__ + "static/painting - 1-a97c105711a6ef82a85b156f31939f7c.jpg";